/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEarlyVersion: {
  name: 'early-version';
  data: string;
} = {
  name: 'early-version',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1.519A6.5 6.5 0 1 0 14.5 8c0-1.993-1.355-3.837-3-5.062V4.5a.5.5 0 0 1-1 0V2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-1.443C14.158 3.841 15.5 5.784 15.5 8A7.5 7.5 0 1 1 8 .5a.5.5 0 0 1 .5.5v4.55a2.5 2.5 0 1 1-1 0V1.519ZM8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
